/**
 * Upload limit of the contract import — mirrors `ContractImportLimits.MaxFileSizeBytes`
 * in the backend (25 MiB). Checked before the upload so an oversized PDF never leaves the
 * browser; the backend still rejects it with `contractImport.fileTooLarge`.
 */
export const CONTRACT_MAX_FILE_BYTES = 25 * 1024 * 1024;

/** The limit as shown to the user ("25 MB"). */
export const CONTRACT_MAX_FILE_MB = CONTRACT_MAX_FILE_BYTES / (1024 * 1024);

export function isContractFileTooLarge(file: Pick<File, 'size'>): boolean {
  return file.size > CONTRACT_MAX_FILE_BYTES;
}
